module.exports = __webpack_public_path__ + "img/12221_21.b84b9d10.png";